<template>
    <div id="myC2c">
        <Header title="C2C" class="headerBox" :showBack="true"></Header>
        <!-- 导航tab -->
        <van-tabs
                v-model="activeTab"
                :border="false"
                background="#f9f9f9"
                color="#1FC26D"
                line-height="3px"
                line-width="30px"
                title-active-color="#333">
            <van-tab title="我的广告" name="all">
                <all v-if="activeTab==='all'"></all>
            </van-tab>
            <van-tab title="未完成订单" name="unfinished">
                <unfinished v-if="activeTab==='unfinished'"></unfinished>
            </van-tab>
            <van-tab title="已完成订单" name="done">
                <done v-if="activeTab==='done'"></done>
            </van-tab>
            <van-tab title="我的申诉" name="complain">
                <complain v-if="activeTab==='complain'"></complain>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import Header from "../../components/header";
    import all from "./components/all.vue";
    import unfinished from "./components/unfinished.vue";
    import done from "./components/done.vue";
    import complain from "./components/complain.vue";

    export default {
        name: "my-c2c",
        components: {
            Header,
            all,
            unfinished,
            done,
            complain,
        },
        data() {
            return {
                activeTab: "all"
            }
        }
    }
</script>

<style lang="scss" scoped></style>
